import Phaser from 'phaser';

export type PowerUpKind = 'rapid' | 'shield' | 'magnet' | 'triple';

export interface PowerUpStyle {
  color: number;
  letter: string;
  label: string;
}

export const POWERUP_STYLES: Record<PowerUpKind, PowerUpStyle> = {
  rapid: { color: 0xff8c1a, letter: 'R', label: 'RAPID FIRE' },
  shield: { color: 0x4ac8ff, letter: 'S', label: 'SHIELD' },
  magnet: { color: 0xc864ff, letter: 'M', label: 'STAR MAGNET' },
  triple: { color: 0x6cd97a, letter: 'T', label: 'TRIPLE SHOT' },
};

export const POWERUP_DURATION_MS: Record<PowerUpKind, number> = {
  rapid: 6000,
  shield: 999999, // shield lasts until consumed
  magnet: 8000,
  triple: 6000,
};

/**
 * Drop pickup. Spawned by killed UFOs (with low probability). Floats with
 * a slight bob. Picked up by overlap with the dino.
 */
export class PowerUp extends Phaser.Physics.Arcade.Sprite {
  readonly kind: PowerUpKind;

  constructor(scene: Phaser.Scene, x: number, y: number, kind: PowerUpKind) {
    super(scene, x, y, `power-${kind}`);
    this.kind = kind;
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.setOrigin(0.5, 0.5);
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setAllowGravity(true);
    body.setVelocityY(40);
    body.setSize(10, 10);
    body.setBounce(0.4, 0.4);
    body.setDragX(80);

    // Bob and pulse so it reads as collectable, not as a hazard.
    scene.tweens.add({
      targets: this,
      scale: { from: 1, to: 1.18 },
      duration: 380,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });
  }
}
